import React from 'react'
import RoomTypePresenterGeneral from './tabs/RoomTypePresenterGeneral'
import RoomTypePresenterAmenities from './tabs/RoomTypePresenterAmenities'
import RoomTypePresenterHousekeepingTypes from './tabs/RoomTypePresenterHousekeepingTypes'
import RoomTypePresenterImageGroup from './tabs/RoomTypePresenterImageGroup'
import RoomTypePresenterIncidentalDeposit from './tabs/RoomTypePresenterIncidentalDeposit'
// import RoomTypePresenterPrice from './tabs/RoomTypePresenterPrice'
import RoomTypePresenterPrices from './tabs/RoomTypePresenterPrices'

import RoomTypePresenterRooms from './tabs/RoomTypePresenterRooms'
import RoomTypePresenterRates from './tabs/RoomTypePresenterRates'
import RoomTypePresenterProducts from './tabs/RoomTypePresenterProducts'
import RoomTypePresenterHistory from './tabs/RoomTypePresenterHistory'
import RoomTypePresenterChannelManagement from './tabs/RoomTypePresenterChannelManagement'


export default class RoomTypePresenterTabContent extends React.Component {

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="tab-content">
        <RoomTypePresenterGeneral {...this.props} />
        <RoomTypePresenterAmenities {...this.props}/>
        <RoomTypePresenterHousekeepingTypes {...this.props}/>
        <RoomTypePresenterImageGroup {...this.props} />
        <RoomTypePresenterIncidentalDeposit {...this.props} />
        {/* <RoomTypePresenterPrice {...this.props} /> */}
        <RoomTypePresenterPrices {...this.props} />

        <RoomTypePresenterProducts {...this.props} />
        <RoomTypePresenterRooms {...this.props} />
        <RoomTypePresenterRates {...this.props} />
        <RoomTypePresenterChannelManagement {...this.props} />
        <RoomTypePresenterHistory {...this.props} />
      </div>
    );
  };
};
